import classNames from 'classnames';
import { Dropdown } from '@/shared/components/flip-ui-kit/Dropdown';
import { usePolkadot } from '@/shared/hooks/usePolkadot';
import CloseCircleIcon from '@/shared/icons/flip-ui-kit/large/CloseCircle';
import DotsHorizontalIcon from '@/shared/icons/flip-ui-kit/large/DotsHorizontal';
import DropletIcon from '@/shared/icons/flip-ui-kit/large/Droplet';

export const OrdersTableDropdown = ({
  onRedirect,
  onClose,
}: {
  onRedirect: () => void;
  onClose: () => void;
}) => {
  const { selectedAccount } = usePolkadot();

  return (
    <Dropdown
      contentClassname="w-[148px]"
      buttonContent={<DotsHorizontalIcon />}
      options={[
        {
          label: 'View Pool',
          icon: <DropletIcon />,
          onClick: onRedirect,
        },
        {
          label: 'Close order',
          icon: (
            <CloseCircleIcon
              className={classNames(selectedAccount?.readonly ? 'text-cf-gray-5' : 'text-cf-red-2')}
            />
          ),
          onClick: onClose,
          disabled: selectedAccount?.readonly,
        },
      ]}
    />
  );
};
